import { __extends } from "tslib";
import { AssetBase } from '@awayjs/core';
import { TesselatedFontTable } from './TesselatedFontTable';
import { BitmapFontTable } from './BitmapFontTable';
/**
 * Font is a container for FontTables.
 *
 *
 *
 */
var Font = /** @class */ (function (_super) {
    __extends(Font, _super);
    /**
   * Creates a new TesselatedFont object
   */
    function Font() {
        var _this = _super.call(this) || this;
        _this._font_styles = [];
        _this.fontName = null;
        _this.regularFontStyle = null;
        return _this;
    }
    // ------------ dummys for as3web:
    Font.registerFont = function (any) { };
    Object.defineProperty(Font.prototype, "font_styles", {
        // ------------
        get: function () {
            return this._font_styles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Font.prototype, "assetType", {
        /**
       *
       */
        get: function () {
            return Font.assetType;
        },
        enumerable: true,
        configurable: true
    });
    /**
   *
   */
    Font.prototype.dispose = function () {
        var len = this._font_styles.length;
        for (var i = 0; i < len; ++i) {
            this._font_styles[i].dispose();
        }
        this._font_styles.length = 0;
    };
    Font.prototype.replace_font_table = function (style_name, table) {
        var len = this._font_styles.length;
        for (var i = 0; i < len; ++i) {
            if (this._font_styles[i].name == style_name) {
                /*if(style_name!=FontStyleName.STANDART){
                    this._font_styles[i].fallbackTable=this.regularFontStyle;
                }*/
                this._font_styles[i] = table;
            }
        }
    };
    /**
   *Get a font-table for a specific name, or create one if it does not exists.
   */
    Font.prototype.get_font_table = function (style_name, assetType, openTypeFont, createTable) {
        if (assetType === void 0) { assetType = TesselatedFontTable.assetType; }
        if (openTypeFont === void 0) { openTypeFont = null; }
        if (createTable === void 0) { createTable = true; }
        var len = this._font_styles.length;
        /*if(this.regularFontStyle==null){
            for (var i:number = 0; i < len; ++i) {
                if((this._font_styles[i].assetType==assetType)&&(this._font_styles[i].name==FontStyleName.STANDART)){
                    this.regularFontStyle=this._font_styles[i];
                }
            }
        }*/
        //console.log("font name", this.name, style_name);
        for (var i = 0; i < len; ++i) {
            if (this._font_styles[i].assetType == assetType &&
                this._font_styles[i].name == style_name) {
                /*if(style_name!=FontStyleName.STANDART){
                    this._font_styles[i].fallbackTable=this.regularFontStyle;
                }*/
                return this._font_styles[i];
            }
        }
        if (!createTable)
            return null;
        var font_style = null;
        if (assetType == TesselatedFontTable.assetType) {
            font_style = new TesselatedFontTable(openTypeFont);
        }
        else if (assetType == BitmapFontTable.assetType) {
            font_style = new BitmapFontTable();
        }
        font_style.name = style_name;
        font_style.font = this;
        this._font_styles.push(font_style);
        /*
        if(style_name==FontStyleName.STANDART){
            this.regularFontStyle=font_style;
            for (var i:number = 0; i < len; ++i) {
                if(this._font_styles[i].name!=FontStyleName.STANDART){
                    this._font_styles[i].fallbackTable=this.regularFontStyle;
                }
            }
        }
        else{
            font_style.fallbackTable=this.regularFontStyle;
        }
        */
        return font_style;
    };
    Font.assetType = '[asset Font]';
    return Font;
}(AssetBase));
export { Font };
